// @generated by protoc-gen-es v2.11.0 with parameter "ts_nocheck=true,target=ts"
// @generated from file ssocloud.proto (package SsoCloud, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ssocloud.proto.
 */
export const file_ssocloud: GenFile =
  /*@__PURE__*/
  fileDesc(
    "Cg5zc29jbG91ZC5wcm90bxIIU3NvQ2xvdWQivwEKD1Nzb0Nsb3VkUmVxdWVzdBIZChFtZXNzYWdlU2Vzc2lvblVpZBgBIAEoDBIVCg1jbGllbnRWZXJzaW9uGAIgASgJEhAKCGVtYmVkZGVkGAMgASgIEgwKBGpzb24YBCABKAgSDAoEZGVzdBgFIAEoCRIUCgxpZHBTZXNzaW9uSWQYBiABKAkSEgoKZm9yY2VMb2dpbhgHIAEoCBIQCgh1c2VybmFtZRgIIAEoCRIQCghkZXRhY2hlZBgJIAEoCCLJAQoQU3NvQ2xvdWRSZXNwb25zZRIPCgdjb21tYW5kGAEgASgJEhkKEW1lc3NhZ2VTZXNzaW9uVWlkGAIgASgMEg0KBWVtYWlsGAMgASgJEhsKE2VuY3J5cHRlZExvZ2luVG9rZW4YBCABKAwSFAoMcHJvdmlkZXJOYW1lGAUgASgJEhQKDGlkcFNlc3Npb25JZBgGIAEoCRIdChVlbmNyeXB0ZWRTZXNzaW9uVG9rZW4YByABKAwSEgoKZXJyb3JUb2tlbhgIIAEoCWIGcHJvdG8z",
  );

/**
 * @generated from message SsoCloud.SsoCloudRequest
 */
export type SsoCloudRequest = Message<"SsoCloud.SsoCloudRequest"> & {
  /**
   * @generated from field: bytes messageSessionUid = 1;
   */
  messageSessionUid: Uint8Array;

  /**
   * @generated from field: string clientVersion = 2;
   */
  clientVersion: string;

  /**
   * @generated from field: bool embedded = 3;
   */
  embedded: boolean;

  /**
   * @generated from field: bool json = 4;
   */
  json: boolean;

  /**
   * @generated from field: string dest = 5;
   */
  dest: string;

  /**
   * @generated from field: string idpSessionId = 6;
   */
  idpSessionId: string;

  /**
   * @generated from field: bool forceLogin = 7;
   */
  forceLogin: boolean;

  /**
   * @generated from field: string username = 8;
   */
  username: string;

  /**
   * @generated from field: bool detached = 9;
   */
  detached: boolean;
};

/**
 * Describes the message SsoCloud.SsoCloudRequest.
 * Use `create(SsoCloudRequestSchema)` to create a new message.
 */
export const SsoCloudRequestSchema: GenMessage<SsoCloudRequest> =
  /*@__PURE__*/
  messageDesc(file_ssocloud, 0);

/**
 * @generated from message SsoCloud.SsoCloudResponse
 */
export type SsoCloudResponse = Message<"SsoCloud.SsoCloudResponse"> & {
  /**
   * @generated from field: string command = 1;
   */
  command: string;

  /**
   * @generated from field: bytes messageSessionUid = 2;
   */
  messageSessionUid: Uint8Array;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: bytes encryptedLoginToken = 4;
   */
  encryptedLoginToken: Uint8Array;

  /**
   * @generated from field: string providerName = 5;
   */
  providerName: string;

  /**
   * @generated from field: string idpSessionId = 6;
   */
  idpSessionId: string;

  /**
   * @generated from field: bytes encryptedSessionToken = 7;
   */
  encryptedSessionToken: Uint8Array;

  /**
   * @generated from field: string errorToken = 8;
   */
  errorToken: string;
};

/**
 * Describes the message SsoCloud.SsoCloudResponse.
 * Use `create(SsoCloudResponseSchema)` to create a new message.
 */
export const SsoCloudResponseSchema: GenMessage<SsoCloudResponse> =
  /*@__PURE__*/
  messageDesc(file_ssocloud, 1);
